import BankIcon from "assets/icon/BankIcon";
import PinLocationIcon from "assets/icon/PinLocationIcon";
import UserIcon from "assets/icon/UserIcon";
import UserXIcon from "assets/icon/UserXIcon";
import { MainBodyCard, PagesTitle, SettingsCard } from "components/Cards";
import { useNavigate } from "react-router-dom";
import { useVariable } from "utils/context/VariableContext";

export default function Setting(){
    let navigate = useNavigate()

    const { isAdmin } = useVariable()

    return(
        <MainBodyCard>
            <PagesTitle title='Setting' />
            
            <div className="mt-4 border rounded-md p-4 bg-white">
                <hr />
                <SettingsCard
                    title='Bank'
                    icon={<BankIcon />}
                    onClick={() => {navigate("/setting/bank")}}
                />
                <hr />
                <SettingsCard
                    title='Mesin EDC'
                    icon={<BankIcon />}
                    onClick={() => {navigate("/setting/edc")}}
                />
                <hr />
                <SettingsCard
                    title='Card Vendor'
                    icon={<BankIcon />}
                    onClick={() => {navigate("/setting/card-vendor")}}
                />
                <hr />
                <SettingsCard
                    title='Transfer Source'
                    icon={<BankIcon />}
                    onClick={() => {navigate("/setting/transfer-source")}}
                />
                <hr />
            </div>
            
            <div className={`border rounded-md bg-white p-4 mt-5 ${isAdmin ? "" : "hidden"}`}>
                <hr />
                <SettingsCard
                    title='Reseller'
                    icon={<UserIcon className="fill-black" />}
                    onClick={() => {navigate("/setting/reseller")}}
                />
                <hr />
                <SettingsCard
                    title='Customer Exeption'
                    icon={<UserXIcon className="fill-black w-6" />}
                    onClick={() => {navigate("/setting/customer-exeption")}}
                />
                <hr />
                <SettingsCard
                    title='Primary Bank Balance'
                    icon={<UserXIcon className="fill-black w-6" />}
                    onClick={() => {navigate("/setting/primary-bank-balance")}}
                />
                <hr />
                <SettingsCard
                    title='Frequent Customer'
                    icon={<UserXIcon className="fill-black w-6" />}
                    onClick={() => {navigate("/setting/frequent-customer")}}
                />
                <hr />
            </div>

            <div className={`border rounded-md bg-white p-4 mt-5 ${isAdmin ? "" : "hidden"}`}>
                <hr />
                <SettingsCard
                    title='Location Setting'
                    icon={<PinLocationIcon className="fill-black" />}
                    onClick={() => {navigate("/setting/location")}}
                />
                <hr />
                <SettingsCard
                    title='User Setting'
                    icon={<UserIcon className="fill-black" />}
                    onClick={() => {navigate("/setting/user")}}
                />
                <hr />
            </div>
        </MainBodyCard>
    )
}
